export const WORKFLOW_INIT = 'WORKFLOW_INIT'
export const WORKFLOW_SAVE = 'WORKFLOW_SAVE'
export const WORKFLOW_UPDATE = 'WORKFLOW_UPDATE'
export const WORKFLOW_SELECT_TAB = 'WORKFLOW_SELECT_TAB'
export const WORKFLOW_UPDATE_GRAPH = 'WORKFLOW_UPDATE_GRAPH'
